// @ts-strict-ignore
import { type SagaIterator } from 'redux-saga';

import { GoalType } from 'constants/goal';
import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { type IActionWithPayload } from 'store/helper';

import {
  type IFetchReportPayload,
  type IReportRequest,
  type IFetchReportOptions,
  ReportRequestName,
} from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchTrackedSales(action: IActionWithPayload<string, IFetchReportPayload>): SagaIterator {
  const requests: IReportRequest[] = [
    {
      name: ReportRequestName.Goals,
      interface: ApiManager.reportApi.fetchGoals,
    },
  ];

  const options: IFetchReportOptions = {
    extendedFilters: { type: GoalType.Sale },
  };

  yield makeFetchingSaga(ReportType.Sales, action, requests, options);
}
